/**
 * Suspense fallback shown while a lazy-loaded route chunk downloads.
 * Kept deliberately tiny (no icons, no deps) since it renders during the
 * exact moment we're trying to minimize network weight.
 */
export default function PageLoading() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]" role="status" aria-live="polite">
      <div
        className="w-8 h-8 rounded-full border-4 border-gray-200 dark:border-gray-700 border-t-primary-600 animate-spin"
        aria-hidden="true"
      />
      <span className="sr-only">Loading page…</span>
    </div>
  );
}
